<template>
    <b-dropdown :text="prettyName(value)" :size="size" variant="outline-secondary" boundary="viewport"
        :disabled="disabled">
        <b-dropdown-item @click="select(null)">
            Store Default Printer
        </b-dropdown-item>
        <b-dropdown-item v-for="printer in printers" :key="printer.name" :active="isSelected(printer)"
            @click="select(printer)">
            {{ printer.name }}
        </b-dropdown-item>
        <b-dropdown-item v-if="printers.length === 0" disabled>
            No local printers found &ndash; install the Scriptly Client Service
        </b-dropdown-item>
    </b-dropdown>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PrintService, PrintDevice } from '@/services/PrintService';

/**
 * Chooses where a formula worksheet prints: the store's default (queue) printer, or one of the
 * local printers the Scriptly Client Service advertises. A `v-model` of the chosen printer (null
 * for the store default); the caller discovers the printers and remembers the choice.
 */
@Component({
    name: 'WorksheetPrinterSelect',
})
export default class WorksheetPrinterSelect extends Vue {
    @Prop({ default: null }) value!: PrintDevice | null;
    @Prop({ type: Array, default: () => [] }) printers!: PrintDevice[];
    @Prop({ type: String, default: 'sm' }) size!: string;
    @Prop({ type: Boolean, default: false }) disabled!: boolean;

    prettyName(printer: PrintDevice | null): string {
        return PrintService.prettyPrinterName(printer);
    }

    isSelected(printer: PrintDevice): boolean {
        return this.value?.name === printer.name;
    }

    select(printer: PrintDevice | null): void {
        this.$emit('input', printer);
    }
}
</script>
